import { render } from "./NewWidgetModal.vue?vue&type=template&id=5d14c572&scoped=true"
import script from "./NewWidgetModal.vue?vue&type=script&lang=js"
export * from "./NewWidgetModal.vue?vue&type=script&lang=js"

import "./NewWidgetModal.vue?vue&type=style&index=0&id=5d14c572&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d14c572"]])

export default __exports__